import { Theme, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { SupplyChainHeader, SupplyChainItemType } from '../supplychain-types';
import { checkForSupplyChainHeader } from '../utils/supply-chain-utils';

const SupplyChainHeaderComp: FC<SupplyChainHeaderProps> = ({
  label,
  link,
  score,
  type,
  position,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();

  if (type === SupplyChainItemType.Element) {
    return (
      <div
        data-testid={`header-label-${position}`}
        className={classes.square}
      />
    );
  }

  return (
    <div className={classes.square} data-testid={`header-label-${position}`}>
      {score && checkForSupplyChainHeader(label) ? (
        <span
          className={classes.severityItem}
          style={{
            backgroundColor: theme.palette.categoryRiskColor[score || 'none'],
          }}
        />
      ) : (
        score !== undefined && <span className={classes.severityItem} />
      )}
      <Typography
        variant='body2'
        color='text.primary'
        fontWeight={600}
        textAlign='center'
        px={1}
        component={link ? NavLink : 'p'}
        to={link}
        display='block'>
        {label}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  square: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  severityItem: {
    borderRadius: 2,
    border: 'none',
    display: 'inline-block',
    width: 8,
    height: 8,
  },
}));

interface SupplyChainHeaderProps {
  type: SupplyChainItemType;
  label: SupplyChainHeader['label'];
  categoryName: SupplyChainHeader['categoryName'];
  link: SupplyChainHeader['link'];
  score: SupplyChainHeader['score'];
  position: number;
}

export default SupplyChainHeaderComp;
